<div class="w-[86%] flex justify-between">
  <div id="header-blur-container"
       class="w-full flex items-center justify-center fixed z-20 top-0 h-6 backdrop-blur-sm"></div>
</div>
<div id="header-main-container" class="header-main-container">
  <div id="header-container" class="header-container">
    <nav id="main-navbar" class="w-full">
      <div class="w-full">
        @if (isLogin) {
          <app-authorized-header/>
        } @else {
          <app-unauthorized-header/>
        }
      </div>
    </nav>
  </div>
</div>
